// Telas do painel do aluno que podem ser restringidas por grupo de acesso.
// A ordem tambem define a prioridade usada para escolher a tela inicial
// do aluno quando a tela padrao (Feed) estiver bloqueada para o grupo dele.
export const STUDENT_SCREENS = [
  {
    key: "feed",
    label: "Feed",
  },
  {
    key: "conteudos",
    label: "Conteúdos",
  },
  {
    key: "tarefas",
    label: "Tarefas",
  },
  {
    key: "vestibulares",
    label: "Vestibulares",
  },
  {
    key: "simuladores-conteudo",
    label: "Simuladores",
  },
  {
    key: "olimpiada-conteudo",
    label: "Olimpíadas",
  },
  {
    key: "rankings",
    label: "Ranking",
  },
  {
    key: "desafios",
    label: "Desafios",
  },
  {
    key: "meritos",
    label: "Méritos",
  },
  {
    key: "agendar",
    label: "Agendamentos",
  },
  {
    key: "cardapio",
    label: "Cardápio",
  },
  {
    key: "transferir",
    label: "Enviar Tokens",
  },
  {
    key: "perfil",
    label: "Perfil",
  },
  {
    key: "extrato",
    label: "Extrato",
  },
];
const SCREEN_FALLBACK_ORDER = STUDENT_SCREENS.map((screen) => screen.key);

/**
 * Retorna o conjunto de telas permitidas para o aluno, ou null quando o
 * aluno tem acesso total (sem grupo de acesso, ou grupo sem restricao).
 */
export function getAllowedScreens(student) {
  const telas = student?.telas_permitidas;
  if (!Array.isArray(telas)) {
    return null;
  }
  return new Set(telas);
}
export function isScreenAllowed(student, screenKey) {
  const allowed = getAllowedScreens(student);
  if (!allowed) {
    return true;
  }
  return allowed.has(screenKey);
}

/**
 * Primeira tela permitida para o aluno, usada como destino padrao apos o
 * login e como fallback ao tentar acessar uma tela bloqueada.
 */
export function resolveStudentHomeScreen(student) {
  const allowed = getAllowedScreens(student);
  if (!allowed) {
    return "feed";
  }
  return SCREEN_FALLBACK_ORDER.find((key) => allowed.has(key)) || "perfil";
}
export { SCREEN_FALLBACK_ORDER };
